module.exports = __webpack_public_path__ + "img/esquemaG.1ff7af77.svg";